import {Response} from '../_metronic/helpers'
import {array} from 'yup'

export interface ModeleSelectInput {
  value?: string
  label?: string
}

export interface ModeleRecherchePiece {
  reference?: string
  referenceVehicule?: string
  nomenclatureTypePiece?: string
}

export const modeleRecherchePieceValues: ModeleRecherchePiece = {
  reference: '',
  referenceVehicule: '',
  nomenclatureTypePiece: '',
}

export interface ModeleRechercheCatalogue {
  referenceConstructeur?: string
  referenceVehicule?: string
  referencePiece?: string
  catalogue?: string | number
  marque?: string
  modele?: string
  codeMoteur?: string
  prixVenteMin?: string | number
  prixVenteMax?: string | number
  typePieces?: string
}

export const modeleRechercheCatalugeValues: ModeleRechercheCatalogue = {
  referenceConstructeur: '',
  referenceVehicule: '',
  referencePiece: '',
  catalogue: '1',
  marque: '',
  modele: '',
  codeMoteur: '',
  prixVenteMin: '',
  prixVenteMax: '',
  typePieces: '',
}

export interface ModeleRechercheVehicule {
  immatriculation?: string
  cnit?: string
}

export const modeleRechercheVehiculeValues: ModeleRechercheVehicule = {
  immatriculation: '',
  cnit: '',
}

export interface ModelePieceItem {
  codePiece?: string
  typePiece?: string
  referenceConstructeur?: string
  prixConstructeur?: string
  prixVenteMin?: string
  prixVenteMax?: string
  stock?: number
}

export interface ModeleVehiculeAndPieces {
  vehicule?: ModeleVehicule | undefined
  donneesImmatriculation?: ModeleImmatriculation | undefined
  donneesPieces?: Array<ModelePieceItem> | undefined
}

export type VehiculeAndPiecesQueryResponse = Response<ModeleVehiculeAndPieces>

export interface ModelePays {
  id?: number
  code2?: string
  code3?: string
  nom?: string
}

export interface ModeleNaf {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleSite {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleCentre {
  id?: number
  code?: string
  nom?: string
  adresse?: string
  complementAdresse?: string
  codePostal?: string
  ville?: string
  telephone?: string
  email?: string
  siret?: string
  pays?: ModelePays
  idPays?: number
  site?: ModeleSite
  codeSite?: string
}

export const modeleCentreInitValues: ModeleCentre = {
  code: '',
  nom: '',
  adresse: '',
  complementAdresse: '',
  codePostal: '',
  ville: '',
  telephone: '',
  email: '',
  siret: '',
  idPays: 75,
  codeSite: '',
}

export interface ModeleClientDocument {
  id?: number
  client?: ModeleClient
  nom?: string
}

export interface ModeleCategorieTypePiece {
  id?: number
  code?: string
  nom?: string
}

export interface ModeleSousCategorieTypePiece {
  id?: number
  code?: string
  nom?: string
  categorie?: ModeleCategorieTypePiece
}

export interface ModeleTypePiece {
  id?: number
  code?: string
  nom?: string
  garantie?: number
  sousCategorie?: ModeleSousCategorieTypePiece
  affichageKilometrage?: boolean
  venteReserveePro?: boolean
  referencementTypePieces?: any
}

export interface ModeleUtilisateurRole {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleUtilisateur {
  id?: number
  nom?: string
  prenom?: string
  email?: string
  pseudo?: string
  roles?: Array<string>
  centres?: Array<string>
  u_centre?: Array<string>
  idRole?: number
  role?: ModeleUtilisateurRole
  password?: string
  passwordConfirmation?: string
  listeFonctionnalites?: Array<string>
  listeModules?: Array<string>
  photoProfil?: string
  listeCentres?: ModeleCentre[]
  listeSources?: ModeleSource[]
  idServiceRattachement?: number
  serviceRattachement?: ModeleServiceRattachement
}

export interface ModeleServiceRattachement {
  id?: number
  libelle?: string
  image?: string
}

export const modeleUtilisateurInitValues: ModeleUtilisateur = {
  nom: '',
  prenom: '',
  email: '',
  pseudo: '',
  roles: [],
  password: '',
  passwordConfirmation: '',
  listeFonctionnalites: [],
  listeModules: [],
  idRole: 1,
  idServiceRattachement: 1,
  centres: [],
  u_centre: [],
  listeCentres: [],
  listeSources: [],
}

export interface ModeleEncours {
  id?: number
  date?: string
  numero?: string
  totalTtc?: number
  resteAPayer?: number
}

export interface ModeleGroupeLIBPR {
  id?: number
  libelle?: string
  typePieces?: any
  description?: string
}

export type UtilisateursQueryResponse = Response<Array<ModeleUtilisateur>>
export type UtilisateurQueryResponse = Response<ModeleUtilisateur>
export type CentreQueryResponse = Response<ModeleCentre>
export type CentresQueryResponse = Response<Array<ModeleCentre>>
export type GenresQueryResponse = Response<Array<ModeleGenre>>
export type GenreQueryResponse = Response<ModeleGenre>
export type CataloguesQueryResponse = Response<Array<ModeleCatalogue>>
export type CatalogueQueryResponse = Response<ModeleCatalogue>
export type ClientEncoursQueryResponse = Response<Array<ModeleEncours>>
export type CourrielQueryResponse = Response<ModeleCourriel>
export type DemandeDemontageQueryResponse = Response<ModeleDemandeDemontage>
export type DemandeTransfertVehiculeQueryResponse = Response<ModeleTransfertStatutVehicule>
export type CommentaireClientDemandeQueryResponse = Response<ModeleCommentaireClientDemande>
export type ReferentielTypePieceQueryResponse = Response<ModeleReferentielTypePiece>
export type ReferentielFournisseurPOTQueryResponse = Response<ModeleReferentielFournisseurPOT>
export type RemiseGroupeClientResponse = Response<ModeleRemise>
export type DemandeDemontageResponse = Response<ModeleDemandeDemontage>
export type ReseauClientQueryResponse = Response<ModeleReseauClient>

export interface ModeleVehiculeGroupe {
  id?: number
  code?: string
}

export interface ModeleVehiculeType {
  id?: number
  code?: string
  idCentreDefaut?: number
  centreDefaut?: ModeleCentre
}

export interface ModeleVehiculeMarque {
  id?: number
  nom?: string
  popularite?: number
}

export interface ModeleVehiculeModele {
  id?: number
  idMarque?: number
  marque?: ModeleVehiculeMarque
  nom?: string
  phase?: string
  cylindre?: string
  puissance?: string
  codeMoteur?: string
  debutPhase?: string
  finPhase?: string
  idType?: number
  type?: ModeleVehiculeType
}

export interface ModeleVehicule {
  id?: number
  idModele?: number
  modele?: ModeleVehiculeModele
  idGroupe?: number
  groupe?: ModeleVehiculeGroupe
  cnit?: string
}

export interface ModeleVehiculeEntre {
  id?: number
  numero?: string
  immatriculation?: string
  vin?: string
  boiteAuto?: boolean
  annee?: number
  energie?: string
  cv?: number
  km?: number
  couleur?: number
  nombrePortes?: number
  datePremiereImmat?: string
  vehicule?: ModeleVehicule
  site?: any
  cnit?: string
  date_entree_stock?: string
  zone?: string
  allee?: string
  codeMoteur?: string
  statut?: string
  marqueModel?: string
  demandeDemontageId?: number | undefined
  demandeTransfertId?: number | undefined
  demandeTransfertValidePar?: ModeleUtilisateur | undefined
  valide?: boolean | undefined
  nombrePhotos?: number
  etat?: string
  destination?: string
  destinationMoteur?: string
  destinationBoite?: string
  typeMoteur?: string
  datePhaseDebut?: string
  datePhaseFin?: string
  boiteAutoManu?: string
  dateDisposition?: string
  centre?: ModeleCentre | undefined
  prixVente?: string | number
  typeBoite?: string
  typeSinistre?: string
  prixAchat?: string
  dateDepollution?: string
  genreCode?: string
  genreLibelle?: string
  emplacement?: string
}

export interface ModeleTypePiecePOT {
  id?: number
  code?: string
  nomPiece?: string
  fournisseur?: string
  prixAchatTTC?: number
  prixVenteTTC?: number
  delaisLivraison?: string
  taxe?: number
  typePiece?: string
  NE?: string
  dateCreation?: string
  creerPar?: ModeleUtilisateur
  demande?: ModeleClientDemande
  typePieceRef?: any
  status?: string
  commandeFournisseur?: string
  provenance?: ModeleProvenance
}

export interface ModeleDemontageStatut {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleDemandeDemontage {
  id?: number
  vehicule?: ModeleVehiculeEntre
  demandePar?: ModeleUtilisateur
  statut?: ModeleDemontageStatut
  validePar?: ModeleUtilisateur
  realisePar?: ModeleUtilisateur
  valideParId?: number | string | undefined | null
  commentaire?: string | undefined
  priorite?: string | undefined
  dateCreation?: string
  dateModification?: string
  dateAnnulation?: string
  listeTypePiece?: ModeleTypePiece[]
  commentaireValidation?: string | undefined | null
  commentaireModification?: string | undefined | null
  commentaireAnnulation?: string | undefined | null
  isValid?: boolean
  demandeTypePiece?: any
  dateDebutRealisation?: string
  dateValidation?: string | undefined | null
  typePieces?: string | undefined | null
  vehiculeId?: string | undefined | null
  demandeParId?: number | undefined | null
  typePieceHn?: string | undefined | null
}

export interface ModelePieceEntre {
  id?: number
  id_piece?: number
  id_vehicule_entre?: number
  id_etat?: number
  code?: string
  prix?: number
  prix_transport?: number
  taux_tva?: number
  id_reserve_demande?: number
  date_reserve_demande?: string
  id_site?: number
  poids?: number
  commentaire?: string
  non_mecanisable?: boolean
  stockage_allee?: string
  stockage_bac?: string
  stockage_date?: string
}

export interface ModeleImmatriculation {
  id?: number
  sCodeErreur?: string
  sMessageErreur?: string
  sNomPartenaire?: string
  sNomPartenaireBase?: string
  sNomLogiciel?: string
  sLicence?: string
  sImmatriculationSiv?: string
  sVin?: string
  sCnit?: string
  stypeVin?: string
  smarque?: string
  smarqueCarrosserie?: string
  smodele?: string
  smodeleEtude?: string
  smodelePrf?: string
  sversion?: string
  senergie?: string
  sgenre?: string
  sgenreCg?: string
  scarrosserie?: string
  scarrosserieCg?: string
  snbVolumes?: string
  snbPortes?: string
  sdatePme?: string
  spuissanceKw?: string
  stypeBoiteVitesse?: string
  stypeVarianteVersion?: string
  spuissanceFiscale?: string
  sco2?: string
  sconsommationMixte?: string
  sconsommationUrbaine?: string
  sconsommationExtraUrbaine?: string
  sdepollution?: string
  scouleur?: string
  sdateCg?: string
  spoidsVide?: string
  spoidsTotalRoulant?: string
  spoidsTotalRoulantPrf?: string
  sempattement?: string
  shauteur?: string
  slargeur?: string
  slongueur?: string
  snbPlacesAssises?: string
  snbCylindres?: string
  snbSoupapes?: string
  smodeInjection?: string
  snbVitesses?: string
  sturbo?: string
  stransmission?: string
  scylindree?: string
  spuissanceCv?: string
  snoSerie?: string
  snoSiren?: string
  scodeMoteur?: string
  sprix?: string
  stecCatid?: string
  stecMarque?: string
  stecCodeMoteur?: string
  stecCodeMoteurTecdocEquivalent?: string
  stecEnergie?: string
  stecCylindree?: string
  stecPuissanceKw?: string
  stecAnneeDeb?: string
  stecAnneeFin?: string
  stecPhase?: string
  stecModele?: string
  stecCarrosserie1?: string
  stecCarrosserie2?: string
  stecNbPortes?: string
  stecTransmission?: string
  stecBoiteVitesse1?: string
  stecBoiteVitesse2?: string
  stecVersion1?: string
  stecVersion2?: string
  stecVersion3?: string
}

export type ImmatriculationQueryResponse = Response<ModeleImmatriculation>

/*
CLIENTS
 */

export interface ModeleClient {
  id?: number
  professionnel?: boolean
  nomSociete?: string
  codeClientAAuto?: string
  codeClientAMoto?: string
  codeClientAIndus?: string
  nom?: string
  prenom?: string
  adresse?: string
  complementAdresse?: string
  codePostal?: string
  ville?: string
  idPays?: number
  pays?: ModelePays
  siren?: string
  telephone?: string
  mobile?: string
  email?: string
  siteWeb?: string
  codeNaf?: string
  libelleCodeNaf?: string
  shopCustomerId?: number
  naf?: ModeleNaf
  group?: string
  typeClient?: string
  prospect?: boolean
  contactGroupError?: string
  isConversionToClient?: boolean
  receptionCommande?: boolean
  isActif?: boolean
  message?: string
  messageBloquant?: boolean
  fraisPortOffert?: boolean
  sauf?: any
  tauxRemise?: any
}

export type ClientSourcesQueryResponse = Response<Array<ModeleClientSource>>

export interface ModeleClientSource {
  id?: number
  source?: string
  codeClient?: string
  nomClientSource?: string
  nomClient?: string
  siren?: string
  codePostalSource?: string
  paysSource?: string
  villeSource?: string
  ville?: string
  nomEntreprise?: string
  denomination?: string
  codeNaf?: string
  libelleCodeNaf?: string
  dateCreation?: string
  dateCreationFormate?: string
  totalEtablissement?: string
  etablissementsClients?: any
  clientSiren?: ModeleClientSource
}

export const modeleClientSourceInitValues: ModeleClientSource = {
  source: '',
  codeClient: '',
  nomClientSource: '',
  nomClient: '',
  siren: '',
  codePostalSource: '',
  paysSource: '',
  villeSource: '',
  ville: '',
  nomEntreprise: '',
  denomination: '',
  codeNaf: '',
  libelleCodeNaf: '',
  dateCreation: '',
  dateCreationFormate: '',
  totalEtablissement: '',
  etablissementsClients: [],
  clientSiren: undefined,
}

export interface ModeleEtablissementClientSource {
  id?: number
  typeEtablissement?: string
  siege?: boolean
  siret?: string
  nic?: string
  numeroVoie?: string
  typeVoie?: string
  complementAdresse?: string
  adresseLigne1?: string
  adresseLigne2?: string
  codePostal?: string
  ville?: string
  codeNaf?: string
  etablissement?: string
  libelleCodeNaf?: string
  dateCreation?: string
}

export const modeleClientInitValues: ModeleClient = {
  professionnel: true,
  idPays: 75,
  codeNaf: '',
  libelleCodeNaf: '',
  nom: '',
  prenom: '',
  adresse: '',
  codePostal: '',
  ville: '',
  telephone: '',
  email: '',
  nomSociete: '',
  codeClientAAuto: '',
  codeClientAIndus: '',
  codeClientAMoto: '',
  siren: '',
  typeClient: '',
  prospect: false,
  isConversionToClient: false,
  receptionCommande: true,
}

export type ClientsQueryResponse = Response<Array<ModeleClient>>
export type ClientQueryResponse = Response<ModeleClient>

export interface ModeleClientOtherData {
  ca?: number
  demandesOk?: number
  demandesPasOk?: number
  dateCreation?: string
}

export const modeleClientOtherDataInitValues: ModeleClientOtherData = {
  ca: 0,
  demandesOk: 0,
  demandesPasOk: 0,
  dateCreation: '',
}

export type ClientOtherDataQueryResponse = Response<ModeleClientOtherData>

export interface ModeleClientAdresse {
  id?: number
  libelle?: string
  adresse?: string
  complementAdresse?: string
  codePostal?: string
  ville?: string
  idPays?: number
  pays?: ModelePays
  telephone?: string
  siret?: string
  idClient?: number
  client?: ModeleClient
  facturation?: boolean
  livraison?: boolean
  adressePrimaireLivraison?: string
  cpPrimaireLivraison?: string
  villePrimaireLivraison?: string
  adresseSecondaireLivraison?: string
  cpSecondaireLivraison?: string
  villeSecondaireLivraison?: string
  idPaysPrimaireLivraison?: number
  paysPrimaireLivraison?: ModelePays
  idpaysSecondaireLivraison?: number
  paysSecondaireLivraison?: ModelePays
  adresseFacturation?: string
  cpFacturation?: string
  villeFacturation?: string
  idPaysFacturation?: number
  paysFacturation?: ModelePays
}

export interface ModeleClientRemise {
  id?: number
  critere?: string
  critereArt?: number
  critereFam?: number
  critereTyp?: number
  codeCritere?: number
  typeCritere?: string
  taux?: number
  tauxArticle?: number
  tauxFamille?: number
  tauxType?: number
  dateDebutArt?: string
  dateDebutFam?: string
  dateDebutTyp?: string
  dateFinArt?: string
  dateFinFam?: string
  dateFinTyp?: string
  dateDebut?: string
  dateFin?: string
  idClient?: number
  remiseFinAnnee?: number
  client?: ModeleClient
}

export const modeleClientRemiseInitValues: ModeleClientRemise = {
  critere: '',
  critereArt: 0,
  critereFam: 0,
  critereTyp: 0,
  codeCritere: 0,
  typeCritere: '',
  taux: 0,
  tauxArticle: 0,
  tauxFamille: 0,
  tauxType: 0,
  dateDebutArt: '',
  dateDebutFam: '',
  dateDebutTyp: '',
  dateFinArt: '',
  dateFinFam: '',
  dateFinTyp: '',
  dateDebut: '',
  dateFin: '',
  idClient: 0,
  remiseFinAnnee: 0,
}

export const modeleClientAdresseInitValues: ModeleClientAdresse = {
  idPays: 75,
  idPaysPrimaireLivraison: 75,
  idpaysSecondaireLivraison: 75,
  idPaysFacturation: 75,
  adresse: '',
  complementAdresse: '',
  codePostal: '',
  ville: '',
  libelle: '',
  siret: '',
  telephone: '',
}

export type ClientAdressesQueryResponse = Response<Array<ModeleClientAdresse>>
export type ClientAdresseQueryResponse = Response<ModeleClientAdresse>

export interface ModeleClientContact {
  id?: number | undefined | null
  nom?: string
  prenom?: string
  telephone?: string
  mobile?: string
  email?: string
  posteOccupe?: string
  principal?: boolean
  client?: ModeleClient
  destinataireCc?: boolean
}

export interface ModeleClientDocument {
  id?: number
  nom?: string
  dateCreation?: string
}

export const modeleClientContactInitValues: ModeleClientContact = {
  nom: '',
  prenom: '',
  telephone: '',
}

export type ClientContactsQueryResponse = Response<Array<ModeleClientContact>>
export type ClientContactQueryResponse = Response<ModeleClientContact>

/*
DEMANDES
 */

export interface ModeleClientDemandeEtape {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleClientDemande {
  id?: number
  dateCreation?: string
  sms?: boolean
  appel?: boolean
  immatriculation?: string
  commentaire?: string
  idCentre?: number
  centre?: ModeleCentre
  idClient?: number
  client?: ModeleClient
  utilisateurSaisie?: ModeleUtilisateur
  idUtilisateurAssigne?: number
  utilisateurAssigne?: ModeleUtilisateur
  clientDemandeEtape?: ModeleClientDemandeEtape
  pieces?: Array<ModeleClientDemandePiece>
  donneesImmatriculation?: ModeleImmatriculation
  cnit?: string
  typePiece: ModeleTypePiece
  refConst?: string | null
  marque?: string | null
  modele?: string | null
  typePieceHn?: string | null
  marqueVht?: string
  idTypePiece?: number | null
  immat?: string | null
  nomTypePiece?: string | null
  dateAssignation?: string | null
  delaiAvantTraitement?: string | null
  delaiTraitement?: string | null
  delaiAvantTraitementReel?: string | null
  delaiTraitementReel?: string | null
  isProposed?: number
  contactedBy?: any
  email?: boolean | null
  communication?: string | null
  retraitDepot?: boolean | null
  commandes?: ModeleCommande[]
  intervention?: boolean
  groupeClient?: string
  delaiIntermediaire?: string | null
  suiviDelaiIntermediaire?: any | null
  dateProposition?: string | null
}

export interface ModeleCommande {
  id?: number
  numCommande?: string
  clientDemande?: ModeleClientDemande
  adresseLiv?: string
  complementAdresseLiv?: string
  cPLiv?: string
  villeLiv?: string
  paysLiv?: string
  telephoneLiv?: string
  adresseFac?: string
  complementAdresseFac?: string
  cPFac?: string
  villeFac?: string
  paysFac?: string
  telephoneFac?: string
  paiementMode?: string
  paiementData?: any
  societe?: string
  paiement?: any
  date?: any
  createur?: string
  commandeItems?: ModeleCommandeItem[]
  montant?: number
  statut?: string
  codePaiement?: string
  pot?: ModeleTypePiecePOT
  pendingPOT?: boolean
}

export interface ModeleCommandeItem {
  id?: number
  commande?: ModeleCommande
  clientDemandePieceProposee?: any
  retraitDepot?: any
}

export const modeleClientDemandeInitValues: ModeleClientDemande = {
  pieces: [],
  immatriculation: '',
  marque: '',
  modele: '',
  typePiece: {},
  isProposed: 0,
}

export type ClientDemandesQueryResponse = Response<Array<ModeleClientDemande>>
export type ClientDemandeQueryResponse = Response<ModeleClientDemande>

export interface ModeleClientDemandePiece {
  id?: number
  stock?: number | string
  referenceManuelle?: string
  commentaire?: string
  neuf?: boolean
  occasion?: boolean
  dispoNeuf?: boolean
  dispoOccasion?: boolean
  delaiNeuf?: number
  delaiOccasion?: number
  prixUnitaire?: number
  idDemande?: number
  demande?: ModeleClientDemande
  idTypePiece?: number
  nomTypePiece?: string
  typePiece?: ModeleTypePiece
  numeroPieceEntre?: string
  idPieceEntre?: number
  pieceEntre?: ModelePieceEntre
  immat?: string
  quantite?: number | string
  refConst?: string | null
  marque?: string | null
  modele?: string | null
  isHorsNomenclature?: string | null
  typePieceHn?: string | null
  centre?: ModeleCentre
  immatriculationNonTrouvee?: string | null
  clientDemandeImmat?: any
  envoiEmail?: boolean
}

export const modeleDemandePieceInitValues: ModeleClientDemandePiece = {
  referenceManuelle: '',
  commentaire: '',
  neuf: false,
  occasion: false,
  dispoNeuf: false,
  dispoOccasion: false,
  delaiNeuf: 0,
  delaiOccasion: 0,
  prixUnitaire: 0,
  quantite: 1,
}

export interface ModelePieceItemStock {
  id?: number
  prixDefaut?: string
  prixConstructeurDate?: string
  typePiece?: ModeleTypePiece
  referenceConstructeur?: string
  prixConstructeur?: string
  prixVenteMin?: string
  prixVenteMax?: string
  stock?: number
  numero_vehicule_entre?: number
  commentaire?: string
  stockageDate?: string
  stockageBac?: string
  code?: string
  prix?: string
  tauxTva?: string
  etat?: any
  piece?: any
  reserveDemande?: string
  nom?: string
  vehiculeEntre?: ModeleVehiculeEntre
  images: any
  site?: any
  stockageAllee?: string | null
  destination?: string | null
}

export interface ModeleGenre {
  id?: number
  code?: string
  libelle?: string
  idCentre?: number
  centre?: ModeleCentre
  idGroupe?: number
  isUsed: boolean
}

export interface ModeleMotif {
  id?: number
  libelle?: string
  isUsed: boolean
}

export const modeleGenreInitValues: ModeleGenre = {
  code: '',
  libelle: '',
  idCentre: 0,
  idGroupe: 0,
  isUsed: false,
}

export interface ModeleEditCentre {
  value: number | undefined
  label: string | undefined
}

export interface ModeleEditSite {
  value: number | undefined
  label: string | undefined
}

// REMISE
export interface ModeleRemise {
  id?: number
  idGroupeClient?: number
  GroupeClient?: ModeleGroupeClient
  taux?: number
  idPiece?: number
  offert?: boolean
  sauf?: any
}

export interface ModeleGroupeClient {
  id?: number
  nom: string
  idRemiseGroupeClient?: number
  RemiseGroupeClient?: ModeleRemise
}

export const modeleRemiseInitValues: ModeleRemise = {
  taux: 0,
  idGroupeClient: 0,
  idPiece: 0,
  sauf: null,
  offert: false,
}

export const modeleMotifRefusInitValues: ModeleMotif = {
  libelle: '',
  isUsed: false,
}

export const modeleReferentielFournisseurPOTInitValues: ModeleReferentielFournisseurPOT = {
  nom: '',
  lien: '',
}

export interface ModeleRole {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleEditRole {
  value: number | undefined
  label: string | undefined
}

export interface ModeleRoleAndModules {
  code: string
  libelle: string
  modules?: any
  status?: boolean
}

export interface ModeleResultSearchCatalogue {
  cataloguePieces: []
  cataloguesDoc: []
}

export interface fonctionnaliteModele {
  id: number
  code: string
  libelle: string
}

export interface ModeleModule {
  id: number
  code: string
  libelle: string
  fonctionnalites: Array<fonctionnaliteModele>
}

export interface ModeleCatalogue {
  id?: number
  nom: string
  token: string
  identiteNom: string
  identitePrenom: string
  raisonSociale: string
  civilite: string
  siret: string
  telephone1: string
  telephone2: string
  mail: string
  tvaIntraCommunautaire: string
  adresseRaisonSociale: string
  adresseNom: string
  adressePrenom: string
  adresseNumVoie: string
  adresseNomVoie: string
  adresseTypeVoie: string
  adresseCodePostal: string
  adresseVille: string
  adressePays: string
  adresseTelephone: string
  codeClientProgiciel: string
  tauxRemiseCatalogue: number
  regles: Array<ModeleRegle[]>
  formatCatalogue: string
  nombreLignes?: number | null
  dateDerniereGeneration?: string | null
  messageErreur?: string | null
}

export interface ModeleRegle {
  c: string
  o: string
  v: string
}

export const modeleRoleInitValues: ModeleRole = {
  code: '',
  libelle: '',
}

export type RolesQueryResponse = Response<Array<ModeleRole>>
export type TypeActionsQueryResponse = Response<Array<ModeleTypeAction>>
export type StatutActionsQueryResponse = Response<Array<ModeleStatutAction>>
export type RoleQueryResponse = Response<ModeleRoleAndModules>
export type ModulesQueryResponse = Response<Array<ModeleModule>>
export type RechercheCatalogueQueryResponse = Response<ModeleResultSearchCatalogue>
export type ModeleHistoriqueFacturationResponse = Response<Array<ModeleHistoriqueFacturation>>
export type ClientDemandePiecesQueryResponse = Response<Array<ModeleClientDemandePiece>>
export type ClientDemandePieceQueryResponse = Response<ModeleClientDemandePiece>
export type RemiseQueryResponse = Response<ModeleClientRemise>
export type CourrielsQueryResponse = Response<Array<ModeleCourriel>>

export type AnyQueryResponse = Response<any>

export interface ModeleClientAcompte {
  id?: number
  date?: string
  numeroDocument?: string
  acompteVerse?: string
  acompteUtilise?: string
  acompteRestant?: string
  client?: ModeleClient
}

export interface ModeleHistoriqueFacturation {
  id?: number | null | undefined
  date?: string
  numero?: string
  montant?: string
}

export const modeleClientAcompteInitValues: ModeleClientAcompte = {}

export type ClientAcomptesQueryResponse = Response<Array<ModeleClientAcompte>>
export type ClientAcompteQueryResponse = Response<ModeleClientAcompte>

export type ClientDocumentsQueryResponse = Response<Array<ModeleClientDocument>>
export type ClientDocumentQueryResponse = Response<ModeleClientDocument>

export interface ModeleCourriel {
  id?: number
  hote?: string
  identifiant?: string
  password?: string
  source?: string
  typeSecurite?: string
  port?: number
  actif?: boolean
}

export interface InfoDemandeImmatSelected {
  idDemande?: number | null
  immat?: string
  idModele?: string | number | null
  idVehicleHorsType?: string | number | null
}

export interface InfoDemandeKPI {
  label: string
  counts: {
    nouvelle: number
    assignee: number
    proposee: number
    acceptee: number
    refusee: number
    cloturePositive: number
    clotureNegative: number
    total: number // Total des demandes par jour/semaine/mois/année selon le filtre
  }
}

export interface ModeleCommentaireClientDemande {
  id?: number
  description?: string
  auteur?: string
  dateCreation?: string
  idClientDemande?: number | string | undefined
  message: string
  utilisateur?: ModeleUtilisateur
}

export interface ModeleReferentielTypePiece {
  id?: number
  referencement?: string[]
  nomTypePiece?: string | undefined | null
  numero?: string | undefined | null
  idRefTypePiece?: string | undefined | null | number
  idTypePiece?: string | undefined | null | number
  typePiece?: ModeleTypePiece
  dureeDisponibilite?: number
  affichageKilometrage?: boolean
  venteReserveePro?: boolean
  sites?: any
}

// export interface ModeleDemandeDemontage {
//   id?: number
//   typePieces?: string | undefined | null
//   vehiculeId?: string | undefined | null
//   demandePar?: ModeleUtilisateur
//   demandeParId?: number | undefined | null
//   commentaire?: string | undefined
//   priorite?: string | undefined
// }

export interface ModeleTransfertStatutVehicule {
  id?: number
  vehicule?: ModeleVehiculeEntre
  vehiculeId?: string | undefined | null
  demandeParId?: number | undefined | null
  commentaire?: string | undefined | null
  valide?: boolean | undefined | null
}

export interface ModelActionDemandeTransfert {
  action: string
  valideParId: number | undefined
  motif?: string | undefined | null
}

export interface ModeleDemandeTransfert {
  id?: number
  vehicule?: ModeleVehiculeEntre | undefined | null
  demandePar?: ModeleUtilisateur | undefined | null
  validePar?: ModeleUtilisateur | undefined | null
  commentaire: string
  dateCreation: string
  valide: boolean
  dateValidation?: string | undefined | null
}

export interface ModeleReferentielFournisseurPOT {
  id?: number
  nom?: string | undefined | null
  lien?: string | undefined | null
  typePiecePOT?: Array<any> | [] | undefined | null
}

export interface ModeleClientDemandeMessage {
  id?: number
  demande?: ModeleClientDemande | undefined | null
  client?: string | undefined | null
  message: string
  luPar: string
  dateCreation?: string
  dateLecture?: string
  dateRealisation?: string
  statut?: string
  mesActions?: ModeleMesActions
}

export interface potInterface {
  code: number | string
  nomPiece: string
  fournisseur: string
  prixAchat: number | string
  prixVente: number | string
  delai: number | string
  taxe: number | string
  ne: number | string
  remise: number | string | undefined | null
  marge: number | string | undefined | null
}

export const potInitValues: potInterface = {
  code: '',
  nomPiece: '',
  fournisseur: '',
  prixAchat: '',
  prixVente: '',
  delai: '',
  taxe: '',
  ne: '',
  remise: '',
  marge:'',
}

export interface ModeleReseauClient {
  id?: number
  code?: string
  nom?: string
}

export const modeleReseauClientInitValues: ModeleReseauClient = {
  code: '',
  nom: '',
}

export interface ModeleTypeDelaisTraitement {
  id: number
  code: string
  libelle: string
}

export interface ModeleDelaisTraitement {
  id?: number
  libelle: string
  type_delais: string
  typeDelaiTraitementDemande?: ModeleTypeDelaisTraitement
  duree: number
  unite: string
  couleur: string
  actif: boolean
}

export interface ModeleProvenance {
  id?: number
  libelle: string
  code?: string | null
  isUsed: boolean
}

export interface SpecificDayTime {
  heureDebut: string
  heureFin: string
}

export interface SpecificDay {
  [key: string]: SpecificDayTime
}

export interface ModeleEquipe {
  id?: number
  nom: string
  isUsed: boolean
  heureDebut?: any
  heureFin?: any
  heureDebutPause?: any
  heureFinPause?: any
  specificDay?: SpecificDay
}

export interface ModeleArticle {
  id?: number
  code: string
  commentaire: string
  isUsed: boolean
}

export interface ModeleDepot {
  id?: number
  nom?: string
  cp?: string
  ville?: string
  adresse?: string
  sourceId?: string
  source?: string
  telephone?: string
  isUsed: boolean
}

export interface ModeleMesActions {
  id?: number
  titre?: string | undefined | null
  type?: string | undefined | null
  statut?: string | undefined | null
  origine?: string | undefined | null
  dateEcheance?: string | undefined | null
  userAssign?: ModeleUtilisateur | undefined | null
  commentaire?: string | undefined | null
  prioritaire?: boolean
  clientId?: number | undefined | null
  demandeId?: number | undefined | null
  lu?: boolean | undefined | null
  commentaireResolution?: string | undefined | null
  dateRealisation?: string | undefined | null
}

export const modeleMesActionsInitValues: ModeleMesActions = {
  titre: '',
  type: undefined,
  statut: undefined,
  origine: 'Manuelle',
  dateEcheance: '',
  userAssign: undefined,
  commentaire: '',
  prioritaire: false,
  clientId: undefined,
  demandeId: undefined,
  dateRealisation: ''
}

export interface ModeleValueLabel {
  value: number | string | undefined
  label: string | undefined
}

export interface ModeleTypeAction {
  id?: number
  code?: string
  libelle?: string
  isUsed?: boolean
}

export const modeleTypesActionsInitValues: ModeleTypeAction = {
  code: '',
  libelle: '',
  isUsed: false,
}

export interface ModeleStatutAction {
  id?: number
  code?: string
  libelle?: string
}

export interface ModelePieceMarchePrix {
  id?: number
  referenceConstructeur?: string
  prixMin1?: string | number
  prixMin2?: string | number
  prixMin3?: string | number
  prixMax1?: string | number
  prixMax2?: string | number
  prixMax3?: string | number
  prixMoyen1?: string | number
  prixMoyen2?: string | number
  prixMoyen3?: string | number
  prixMoyenTotal?: string | number
  date?: string
  totalPiece?: string | number
  prixConstructeur?: string | number
  dateScrapping?: string
  prixConstructeurLacour?: string | number
  dateLacour?: string
}

export interface ModeleModifPrix {
  id?: number | undefined
  codePiece?: string
  prixVente?: string | undefined | null | number
  nouveauPrix?: string | undefined | null | number
  dateImport?: any
  traitee?: any
  refConst?: string | undefined
  source?: string | undefined | null
  prixManuel?: any
  history?: any
  metriques?: any
  code?: string | undefined | null
  nomPiece?: string | undefined | null
  marque?: string | undefined | null
  modele?: string | undefined | null
  idPieceEntree?: number
}

export interface ModeleTypeLibelleDemande {
  id?: number | undefined
  code: string
  commentaire?: string
}

export interface ModeleLibelleDemandePiece {
  id?: number
  libelle?: string
  commentaire?: string | undefined | null
  prixUnitaitre?: number | string | null
  quantite?: number | undefined | null
  typeLibelleDemande?: Array<ModeleTypeLibelleDemande>
  groupeLIBPR?: ModeleGroupeLIBPR
}

export interface ModeleEditSource {
  value: number | undefined
  label: string | undefined
}

export interface ModeleSource {
  id?: number
  code?: string
  libelle?: string
}

export interface ModeleEditProvenance {
  value: number | string | undefined
  label: string | undefined
}

export interface ModeleSourcePiece {
  id?: number
  code?: string
  nom?: string
}

export interface ModeleEditEquipe {
  value: number | string | undefined
  label: string | undefined
}

export interface ModeleDemandeDevis {
  id?: number
  demande?: ModeleClientDemande
  nomFichier?: string
  destinataire?: string
  objet?: string
  message?: string
  envoye?: boolean
  dateCreation?: string
  panier?: any
  utilisateurAssigne?: ModeleUtilisateur
  client?: ModeleClient
  libelle?: any
  contactedBy?: ModeleClientContact
  pieceJointeSupplementaire?: any
  destinataireCc?: string
}

export interface ModelePieceOe {
  id?: number
  refConst?: string | undefined
  tauxTva?: number | undefined
  idModifPrix?: number | undefined
  codePiece?: string
  codeSite?: string
  dateStockage?: string
  etatLibelle?: string
  prixHT?: number | undefined
  nouveauPrix?: number | undefined
}

export interface ModeleAdresseDepot {
  id: string,
  nom: string,
  adresse: string,
  cp: string,
  ville: string,
}